var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["v-signature", _vm.isPopupForMobiles ? "signature-popup" : ""],
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _c("div", [
        _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
        _vm._v(" "),
        !_vm.isDirtyLocal
          ? _c("i", { staticClass: "v-signature__info db-nl" }, [
              _vm._v("(" + _vm._s(_vm.signatureInfo) + ")")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.allowEdit
        ? _c(
            "button",
            {
              staticClass:
                "v-form__button v-form__button--signature v-form__button--edit-signature v-form__button--is-default",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openPopupForMobiles.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.model ? _vm.editSignature : _vm.addSignature) + " "
              )
            ]
          )
        : !_vm.model
        ? _c(
            "button",
            {
              staticClass:
                "v-form__button v-form__button--signature v-form__button--edit-signature v-form__button--is-default",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openPopupForMobiles.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.addSignature) + " ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "v-signature-content" }, [
        _c("i", {
          ref: "infoIcon",
          staticClass: "signature-popup__info-icon hide-hlp"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "v-signature-block" }, [
          !_vm.isDirtyLocal && !_vm.mobileView
            ? _c(
                "div",
                {
                  staticClass: "canvas-holder-wrap",
                  on: { mouseup: _vm.save, touchend: _vm.save }
                },
                [
                  _c("vueSignature", {
                    ref: "signature",
                    class: [
                      "canvas-holder",
                      !!_vm.errors.has(_vm.name) ? "v-input__error--border" : ""
                    ],
                    attrs: { sigOption: _vm.option },
                    on: { mouseup: _vm.save, touchend: _vm.save }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isDirtyLocal && _vm.isPopupForMobiles
            ? _c(
                "div",
                {
                  staticClass: "canvas-holder-wrap",
                  on: { mouseup: _vm.save, touchend: _vm.save }
                },
                [
                  _c("vueSignature", {
                    ref: "signature",
                    class: [
                      "canvas-holder canvas-holder--mobile",
                      !!_vm.errors.has(_vm.name) ? "v-input__error--border" : ""
                    ],
                    attrs: { sigOption: _vm.option }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "v-signature-bottom" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass:
                  "v-form__button v-form__button--signature v-form__button--is-default",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.clear.apply(null, arguments)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.clearSignature))]
            ),
            _vm._v(" "),
            _vm.errors.has(_vm.name)
              ? _c(
                  "span",
                  {
                    staticClass: "v-input__error",
                    staticStyle: { display: "inline" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errors.first(_vm.name)) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "v-form__button v-form__button--save-and-close v-form__button--is-success",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.triggerSaveAndCloseBtn.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.saveAndClose))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isDirtyLocal
        ? _c("img", {
            class: [_vm.model ? "" : "no-sign-saved"],
            attrs: { src: _vm.model },
            on: {
              mouseup: function($event) {
                $event.stopPropagation()
              },
              touchend: function($event) {
                $event.stopPropagation()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        attrs: { type: "hidden", name: _vm.name },
        domProps: { value: _vm.model },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.model = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.errors.has(_vm.newName)
        ? _c("div", { staticClass: "form__field-error" }, [
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.newName)) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3495ae4d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3495ae4d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VSignature.vue
// module id = 336
// module chunks = 1 2